import React from 'react'

export default function Loader() {
  return (
    <div className="flex h-fit justify-center py-52 items-center">
    <div className="relative w-16 h-16">
      <div className="absolute top-0 left-0 w-4 h-4 bg-red-700 rounded-full animate-[orbit_1.2s_linear_infinite]"></div>
      <div className="absolute top-0 left-0 w-4 h-4 bg-yellow-500 rounded-full animate-[orbit_1.2s_linear_infinite] [animation-delay:-0.4s]"></div>
      <div className="absolute top-0 left-0 w-4 h-4 bg-green-700 rounded-full animate-[orbit_1.2s_linear_infinite] [animation-delay:-0.8s]"></div>
    </div>
  
    <style>{`
      @keyframes orbit {
        0% { transform: rotate(0deg) translateX(12px) rotate(0deg); }
        100% { transform: rotate(360deg) translateX(12px) rotate(-360deg); }
      }
    `}</style>
  </div>
  )
}
